var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('campaign-templates',{attrs:{"value":_vm.state.campaignTemplate,"data":_vm.state.campaignTemplates,"loading":_vm.loading},on:{"input":(v) => _vm.setState('campaignTemplate', v)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }